import navToListing from '../../helpers/navToListing';
import ListingPreviewCard from '../ListingPreviewCard';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import useIsListingBlurred from '../../hooks/useIsListingBlurred';

type Props = {
  listing: SimpleListing;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export default function PreviewSidebarItem({
  listing,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const isDetailsBlurred = useIsListingBlurred(listing);
  if (isDetailsBlurred) {
    return (
      <ListingPreviewCard
        listing={listing}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        zoomOnHover={false}
      />
    );
  }
  return (
    <button onClick={() => navToListing(listing)}>
      <ListingPreviewCard
        listing={listing}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        zoomOnHover={true}
      />
    </button>
  );
}
